import type { AppState } from './types'

export const COUNTRIES_URL = '/assets/countries.geo.json'
export const CREATE_ITEM_MIN_ZOOM = 8

export const params = new URLSearchParams(window.location.search)
export const isEmbedMode =
  params.get('embed') === '1' || params.get('mode') === 'embed'

/**
 * App-wide mutable state. Modules read and write directly via the singleton.
 * Initial preferences (`items`, `theme`, `lang`) are populated by main.ts
 * once storage and URL params have been resolved.
 */
export const state: AppState = {
  items: [],
  selectedCountry: '',
  countries: [],
  countryLayer: null,
  markerLayer: null,
  draftMarker: null,
  mediaUrls: new Map<string, string>(),
  theme: 'light',
  lang: 'en',
}
